// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_GqAJ- clearfix","list":"index_list_aJkpq","black_01":"index_black_01_zr-fF","word_01":"index_word_01_ZNxsg"};